









import { Button } from "@/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Dashboard extends Vue {
  @Prop() private buttons!: Button[];
}
